<template>
  <div class="surface-0 overflow-hidden py-4" style="min-height: 100vh;">
  <!-- <div class="overflow-hidden py-4"> -->
    <!-- <div class="py-3 relative my-3" style="min-height: 100vh;" id="hero"> -->
    <div class="pb-3 relative my-3" id="hero">
      <!-- <div class="mx-4 mt-0 w-100 text-center flex justify-content-center"> -->
      <div class="mx-4 mt-0 w-100 text-center">
        <div class="text-center mx-6">
          <img :src="$store.state.master.logo_app" style="width: 100px;" class="" alt="" srcset="">
        </div>
        <div class="">
          <h1 class="text-6xl font-bold text-gray-900 line-height-2 text-center mt-3 mb-0">PPID</h1>
          <h3 class="text-4xl font-bold text-gray-900 line-height-2 text-center mt-0 mb-3">Pejabat Pengelola Informasi dan Dokumentasi</h3>
        </div>
      </div>
    </div>
    <div class="grid mb-6">
      <!-- {{data}} -->
      <div class="md:col-2"></div>
      <div class="col-12 md:col-8 grid card">
        <div class="grid ">
          <div class="col-12 lg:col-6 md:col-6 text-center">
            <img src="images/search.png" class="w-full" alt="" srcset="">
            <!-- <img src="images/logo-undip.png" class="text-center" style="height: 300px;" alt="" srcset=""> -->
          </div>
          <div class="col-12 lg:col-6 md:col-6 grid">
            <p class="text-2xl text-center mt-1 mb-1">Untuk melihat detail laporan anda, silahkan masukkan kode dan type laporan yang anda miliki</p>
            <!-- <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
              <label for="type">Type</label>
              <Dropdown 
                v-model="dataForm.type" 
                :options="$store.state.data_static.jenis_kategori" 
                optionLabel="text" 
                optionValue="value" 
                placeholder="piilh asal pemohon" 
                class="w-full" 
                :disabled="loading" 
              />
            </div> -->
            <div class="col-12 md:col-12 flex flex-column gap-2 sm:my-0 xl:my-1">
              <label for="kode">Kode</label>
              <InputText 
                id="kode" 
                v-model="dataForm.kode" 
                aria-describedby="kode-help" 
                :disabled="loading" 
              />
            </div>
            <Button class="w-full mb-0 mt-3" label="Cari Laporan" @click="search()" :disabled="loading" />
            <Button class="w-full mb-0 mt-3" label="Form Permohonan / Pengajuan" :disabled="loading" @click="$router.push('/laporan')"/>
            <!-- <span class="mt-3">
              belum mepunyai laporan?, untuk membuat laporan silahkan 
              <router-link to="/laporan">klik disini</router-link>
            </span> -->
          </div>
        </div>
      </div>
      <div class="md:col-2"></div>
      <div v-if="data[data.jenis_kategori + '_id']" class="md:col-2"></div>
      <div v-if="data[data.jenis_kategori + '_id']" class="col-12 md:col-8 grid mt-4 card">
        <div class="col-12 md:col-12 flex md:flex-row sm:flex-column md:text-left sm:text-center justify-content-between gap-2 mt-1">
          <h5 class="m-0 p-0 text-primary">
            {{keterangan}}
          </h5>
          <h5 class="m-0 p-0 text-primary">{{$moment(data['tanggal_pengaduan']).format('LL')}}</h5>
        </div>
        <div v-if="data.kode_tindakan_selanjutnya" class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="type">Kode selanjutnya</label>
          <h5 class="m-0 p-0">{{data.kode_tindakan_selanjutnya}}</h5>
        </div>
        <div v-if="data['kode_' + data.jenis_kategori + '_sebelumnya']" class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="type">Kode Sebelumnya</label>
          <h5 class="m-0 p-0">{{data['kode_' + data.jenis_kategori + '_sebelumnya']}}</h5>
        </div>
        <div class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="type">Asal</label>
          <h5 class="m-0 p-0">{{data.asal_pemohon}}</h5>
        </div>
        <div class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="type">Kategori</label>
          <h5 class="m-0 p-0">{{data.nama_kategori}}</h5>
        </div>
        <div v-if="data.nama_biro" class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="type">Biro</label>
          <h5 class="m-0 p-0">{{data.nama_biro}}</h5>
        </div>
        <div v-if="data.nama_fakultas" class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="type">Fakultas</label>
          <h5 class="m-0 p-0">{{data.nama_fakultas}}</h5>
        </div>
        <div v-if="data.nama_prodi" class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="type">Prodi</label>
          <h5 class="m-0 p-0">{{data.nama_prodi}}</h5>
        </div>
        <div class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="type">Nama</label>
          <h5 class="m-0 p-0">{{data.nama_pemohon}}</h5>
        </div>
        <div class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="type">Email</label>
          <h5 class="m-0 p-0">{{data.email_pemohon}}</h5>
        </div>
        <div class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="type">No Identitas</label>
          <h5 class="m-0 p-0">{{data.no_identitas}}</h5>
        </div>
        <div class="col-12 md:col-6 flex flex-column gap-2 mt-1">
          <label for="type">No Handphone</label>
          <h5 class="m-0 p-0">{{data.no_hp_pemohon}}</h5>
        </div>
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="type">Foto Identitas Diri</label>
          <Image class="text-left" :src="$store.state.ipBackend + '/' + data.foto_identitas" alt="Image" width="250" preview />
        </div>
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="type">Deskripsi</label>
          <h5 class="m-0 p-0">{{data['deskripsi_' + data.jenis_kategori]}}</h5>
        </div>
        <div v-if="data.file_laporan1 || data.file_laporan2" class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="username">File</label>
          <div v-if="data.file_laporan1" class="p-inputgroup flex-1">
            <Button label="open" @click="openNewTab(data.file_laporan1)"/>
            <InputText id="file_laporan1" v-model="data.file_laporan1" aria-describedby="file_laporan1-help" readonly/>
          </div>
          <div v-if="data.file_laporan2" class="p-inputgroup flex-1">
            <Button label="open" @click="openNewTab(data.file_laporan2)"/>
            <InputText id="file_laporan2" v-model="data.file_laporan2" aria-describedby="file_laporan2-help" readonly/>
          </div>
        </div>
      </div>
      <div v-if="data.id" class="md:col-2"></div>
      <div v-if="data.id" class="md:col-2"></div>
      <div v-if="data.id && data.catatan_manajer" class="col-12 md:col-8 grid mt-4 card">
          <!-- {{data}} -->
        <div v-if="setuju" class="col-12 md:col-12 text-right gap-2 mt-1">
          <h5 class="m-0 p-0 text-primary">{{setuju}}</h5>
        </div>
        <div class="col-12 md:col-12 flex flex-column gap-2 mt-1">
          <label for="type">Balasan</label>
          <h5 class="m-0 p-0">{{data.catatan_manajer}}</h5>
        </div>
        <div v-if="data.catatan_manajer && !setuju" class="p-buttonset w-full mt-3">
          <Button class="w-6" severity="success" label="Setuju" @click="pilihSetuju(1)" :disabled="loading || setuju" />
          <Button class="w-6" severity="danger" label="Tidak Setuju" @click="pilihSetuju(2)" :disabled="loading || setuju" />
        </div>
      </div>
      <div v-if="data.id" class="md:col-2"></div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { load } from 'recaptcha-v3'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return {
			domain: window.location.origin,
			loading: false,
      dataForm: {
        kode: null,
        // type: null,
      },
      data: {},
      recaptcha: null,
    }
  },
  computed: {
    isValid() {
      return !this.v$.dataForm.$invalid;
    },
    setuju() {
      let status = this.data.is_setuju
      if(status === 1){
        return 'Menyetujui'
      }else if(status === 2){
        return 'Tidak Menyetujui'
      }else{
        return null
      }
    },
    keterangan(){
      const vm = this
      switch (vm.data['status_' + vm.data.jenis_kategori]) {
        case 0:
          return `MOHON MAAF ${vm.data.jenis_kategori.toUpperCase()} ANDA TERMASUK INFORMASI YANG DIKECUALIKAN`
        case 1:
        case 2:
        case 3:
          return `${vm.data.jenis_kategori.toUpperCase()} SEDANG DALAM PROSES`
        case 4:
          return `${vm.data.jenis_kategori.toUpperCase()} SELESAI DI PROSES`
        default:
          return ''
      }
    },
  },
  validations () {
    return {
      dataForm: {
        kode: { required },
        // type: { required },
      }
    }
  },
  async mounted() {
    const vm = this
    // console.log(vm.$route.query)
    // vm.dataForm.type = vm.$route.query.type || vm.$store.state.data_static.jenis_kategori[0].value
    vm.recaptcha = await load(process.env.VUE_APP_KEYSITECAPTCHA, {
      // autoHideBadge: true,
    })
    vm.dataForm.kode = vm.$route.query.kode
    if(vm.isValid) vm.search()
  },
  methods: {
    openNewTab(path){
      window.open(this.$store.state.ipBackend + '/' + path)
    },
    async pilihSetuju(status){
      const vm = this
      const res = await vm.$axios.post(vm.data.jenis_kategori + '/update', {
        id: vm.data[vm.data.jenis_kategori + '_id'],
        is_setuju: status
      })
      if(res.data.status == 200){
        if(status === 1){
          vm.search()
        }else{
          vm.$router.push('/laporan?type=' + vm.data.jenis_kategori + '&kode=' + vm.data['kode_' + vm.data.jenis_kategori])
        }
        vm.$toast.add({ severity: 'success', summary: 'Konfirmasi', detail: 'Berhasil Mengirim Persetujuan', life: 3000 });
      }else{
        vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Gagal Mengirim Persetujuan', life: 3000 });
      }
    },
    async search(){
      const vm = this
      // console.log(await vm.recaptcha.execute('login'))
      try {
        if(vm.isValid){
          const captcha = await vm.recaptcha.execute('login')
          const res = await vm.$axios.post('gabungan/details_by_code', {kode: vm.dataForm.kode, captcha})
          if(res.data.status == 200 && res.data.data.length >= 1){
            vm.data = res.data.data[0]
            vm.$toast.add({ severity: 'success', summary: 'Konfirmasi', detail: 'Data Ditemukan', life: 3000 });
          }else{
            vm.data = {}
            vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Data Tidak Valid', life: 3000 });
          }
        }else{
          vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Data Tidak Valid', life: 3000 });
        }
      } catch (error) {
        // console.log('error', error)
        vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: error.response.data.message, life: 3000 });
      }
    }
  },
}
</script>

<style>
</style>